// extracted by mini-css-extract-plugin
export var sectionContainer = "Banner-module--sectionContainer--3Q6Gy";
export var imageContainer = "Banner-module--imageContainer--13Stu";
export var imagesWrapper = "Banner-module--imagesWrapper--2YX4_";
export var logoContainer = "Banner-module--logoContainer--3dJNR";
export var bannerText = "Banner-module--bannerText--17VMy";